

import apiClient from 'api/apiClient';
import { getAuthenticatedSession } from 'cognito/auth';

export async function putStravaLink ( authenticatedUser, state, code, scope )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    return apiClient.put ( authenticatedUser.username + "/strava",
                {
                    state: state,
                    code: code,
                    scope: scope
                },
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}